import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'app/store';
import { signOut } from 'app/store/authSlice';

/**
 * useSettingsMenuActions - Custom hook for settings menu actions
 * Centralized menu action logic to improve DRY principles
 */
export const useSettingsMenuActions = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleSignOut = () => {
    dispatch(signOut())
      .unwrap()
      .then(() => {
        navigate('/login');
      })
      .catch(() => {
        // If sign out fails, still navigate to login
        navigate('/login');
      });
  };

  return {
    handleSignOut,
    navigate,
  };
};
